<template>
  <div>
    <div v-if="!loading" class="detail" >
      <div class="detail_outer_wrapper">
        <div class="detail_wrapper">
          <router-link v-if="!isRedirect" class="back_to_list" :to="{path:from?decodeURIComponent(from): '/records'}">
            <Icon type="ios-arrow-back" />{{from?'返回':'返回点播列表'}}
          </router-link>
          <div class="detail_container">
            <div id="Detail" v-if="course">
              <div class="media-video background-image-cover">
                <div class="empty_video" v-if="videos.length === 0">暂无视频</div>
                <router-view style="height: 100%;"></router-view>
              </div>
              <div class="detail_message">
                <div class="detail_message_content">
                  <p class="detail_title">
                    <span>{{course.title}}</span>
                  </p>
                  <div class="detail_other">
                    <div class="item date">{{gmtModified | Date('{y}-{m}-{d}')}}</div>
                    <div class="item splice_line"></div>
                    <div v-if="!isRedirect" class="item share" @click="handleShowPoster()">
                      <Icon type="md-share" />
                      <span>生成专属海报</span>
                    </div>
                    <Poptip placement="bottom" width="400" :visible.sync="courseWareVisible" @on-popper-hide="courseWareVisible=false">
                      <div class="item attach" @click="courseWareVisible=true">
                        <Icon type="md-attach" />
                        <span>课件</span>
                      </div>
                      <template slot="content">
                        <Courseware v-if="courseWareVisible" :course="course"></Courseware>
                      </template>
                    </Poptip>
                    <!-- <Poptip placement="bottom" width="300" v-if="!isRedirect3C">
                      <div class="item contact">
                        <Icon type="md-person" />
                        <span>课程联系人</span>
                      </div>
                      <template slot="content">
                        <div class="contact_hit" v-if="!course.contactUrl">
                          <span class="hint-info">暂无课程联系人</span>
                        </div>
                        <img class="contact_img" v-else :src="course.contactUrl"/>
                      </template>
                    </Poptip> -->
                  </div>
                </div>
              </div>
              <CoursePoster :courseId="course.id"/>
            </div>
            <main v-if="course">
              <CourseSideBar :course="course" :videos="videos"></CourseSideBar>
            </main>
          </div>
        </div>
      </div>
      <div v-if="course" class="detail_description">
        <Tabs :value="tabValue" ref="tabs">
          <TabPane label="课程简介" name="description">
            <div>{{course.description}}</div>
          </TabPane>
        </Tabs>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CourseSideBar from './detail/CourseSideBar'
import CoursePoster from '@/components/business/CoursePoster'
import sensorHelp from '@/vendor/sensors/help'
import { RECORD_DETAIL_VISIT } from '@/constant/sensorEvent'
import Courseware from '@/views/components/Courseware'
import { FISCAL_TAX, CCC } from '@/constant/constants'
export default {
  name: 'RecordDetail',
  components: {
    CourseSideBar,
    CoursePoster,
    Courseware,
  },
  data () {
    return {
      from: '',
      course: null,
      videos: [],
      loading: false,
      tabValue: 'description',
      isRedirect: sessionStorage.getItem('redirectType') === FISCAL_TAX || sessionStorage.getItem('redirectType') === CCC,
      isRedirect3C: sessionStorage.getItem('redirectType') === CCC,
      courseWareVisible: false,
      gmtModified: '',
    }
  },
  computed: {
    ...mapState('course', ['showPoster']),
  },
  created () {
    this.init()
  },
  methods: {
    // 获取课程详情
    getCourseDetail () {
      this.loading = true
      this.$store.dispatch('course/getRecord', { courseId: this.$route.params.courseId }).then(course => {
        this.course = course
        // 获取课程列表
        this.$store.dispatch('course/getVideos', { recordPkid: course.id, page: 1, pageSize: 99 }).then(res => {
          this.loading = false
          this.videos = res.list

          var vid = res.list.filter(item => this.$route.params.videoId == item.id)
          if (this.$route.params.videoId != undefined) {
            this.gmtModified = vid[0].gmtModified
          } else {
            if (this.videos.length>0) {
              this.gmtModified = this.videos[0].gmtModified
            } else {
              this.gmtModified = this.course.gmtModified
            }
          }

          if (!this.$route.params.videoId && this.videos.length > 0) {
            this.$router.push(`/record/detail/${course.id}/${this.videos[0].id}`)
          }
        })
        sensorHelp.track(RECORD_DETAIL_VISIT, {
          school_course_id: course.id,
        })
      }).catch(({ msg, code }) => {
        if (code === 4001 || code === 4006) {
          this.$router.push({ name: 'Login' })
        }
      })
    },
    init () {
      this.getCourseDetail()
      this.from = this.$router.currentRoute.query.from
    },
    handleShowPoster () {
      this.$store.commit('course/setShowPoster', true)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/detail.scss';
.detail {
  // overflow: hidden;
  background-color: #fff;
}
.detail_wrapper {
  #Detail {
    .media-video {
      .empty_video {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #919191;
      }
    }
  }
}
</style>
